/** Role helpers for BMS access control */

export const ROLES = {
  SUPERADMIN: "superadmin",
  ADMIN: "admin",
  PACKER: "packer",
  QC: "qc",
  USER: "user",
};

export const getUserRole = () =>
  typeof localStorage !== "undefined" ? localStorage.getItem("userRole") || "" : "";

/** Former full-admin powers (Show All, Reports, Administration, etc.) */
export const isSuperAdmin = (role = getUserRole()) => role === ROLES.SUPERADMIN;

/** Admin-level ops that both superadmin and admin may do */
export const isAdminLike = (role = getUserRole()) =>
  role === ROLES.SUPERADMIN || role === ROLES.ADMIN;

/** FAI/PDI edit & delete: superadmin + qc (admin is view-only) */
export const canEditFaiPdi = (role = getUserRole()) =>
  role === ROLES.SUPERADMIN || role === ROLES.QC;

/** Wire stock clear / delete wire name */
export const canManageWireStockDelete = (role = getUserRole()) =>
  role === ROLES.SUPERADMIN;
